import { ELLIPSIS_ACTION_LIST } from "./DefaultEllipsisActions";
import {
	TRANSCODING_ELLIPSIS_ACTION_LIST,
	TRANSCODED_ELLIPSIS_ACTION_LIST } from "./TranscodingEllipsisActions";
import { APPROVAL_ACTION_LIST } from "./ApprovalActions";
import { PREVIEW_ACTION_LIST } from "./PreviewActions";
import { VERSION_ACTION_LIST } from "./VersionActions";
import { EDIT_SOCIAL_ACTION_LIST } from "./EditSocialActions";

const CREATIVE_ACTION_LISTS = {
	PREVIEW_ACTION_LIST,
	APPROVAL_ACTION_LIST,
	VERSION_ACTION_LIST,
	EDIT_SOCIAL_ACTION_LIST,
	ELLIPSIS_ACTION_LIST,
	TRANSCODING_ELLIPSIS_ACTION_LIST,
	TRANSCODED_ELLIPSIS_ACTION_LIST,
};

export default CREATIVE_ACTION_LISTS;
